/* models/customselect.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    var _a;
    const selectbox_1 = require("@bokehjs/models/widgets/selectbox");
    class CustomSelectView extends selectbox_1.SelectView {
        connect_signals() {
            super.connect_signals();
            this.connect(this.model.properties.disabled_options.change, () => this._update_disabled_options());
        }
        options_el() {
            let opts = super.options_el();
            opts.forEach((element) => {
                if (this.model.disabled_options.includes(element.value)) {
                    element.setAttribute('disabled', 'true');
                }
            });
            return opts;
        }
        _update_disabled_options() {
            for (const element of this.input_el.options) {
                if (this.model.disabled_options.includes(element.value)) {
                    element.setAttribute('disabled', 'true');
                }
                else {
                    element.removeAttribute('disabled');
                }
            }
        }
    }
    exports.CustomSelectView = CustomSelectView;
    CustomSelectView.__name__ = "CustomSelectView";
    class CustomSelect extends selectbox_1.Select {
        constructor(attrs) {
            super(attrs);
        }
    }
    exports.CustomSelect = CustomSelect;
    _a = CustomSelect;
    CustomSelect.__name__ = "CustomSelect";
    CustomSelect.__module__ = "panel.models.widgets";
    (() => {
        _a.prototype.default_view = CustomSelectView;
        _a.define(({ Array, String }) => {
            return {
                disabled_options: [Array(String), []],
            };
        });
    })();
}
